import { PLAN_TYPES } from '../../../../models/Plan';
import './action-list.scss';
import CopyPlanButton from './copy-plan-button/copy-plan-button';
import EditPlanButton from './edit-plan-button/edit-plan-button';

interface ActionListProps {
    planId: number;
    type: PLAN_TYPES;
}

const ActionList: React.FC<ActionListProps> = ({ planId, type }) => {
    return (
        <span className='action-list'>
            <EditPlanButton planId={planId} type={type} />
            <CopyPlanButton planId={planId}  />
        </span>
    );
};

export default ActionList;
